/* eslint-disable jsx-a11y/media-has-caption */
import React from "react"

import video720 from "../../videos/o3_satellite_rotation_cropped.mp4"
import poster from "../../images/o3_satellite_rotation_cropped.jpg"

const Video = () => (
  <video loop playsInline preload="auto" autoPlay poster={poster}>
    <source src={video720} type="video/mp4" />
  </video>
)

export default Video